module.exports = __webpack_public_path__ + "static/img/12areaB_01.449b8a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_01.png
// module id = 1102
// module chunks = 1